/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";

//custom libraries
import { METHOD, USER_ROLES } from "../../constants/requests";
import { useRestService } from "./use-rest-service";
import { SKIP_MESSAGE_SNACKBAR } from "../../constants/message";

export const useUserResource = () => {
  const { executeV2Request, executeRequest } = useRestService();

  const getCSRRoles = (csr: any) => {
    const { userId, WCToken, WCTrustedToken } = csr;
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.GET,
      url: USER_ROLES.replace("{userId}", userId),
      headers: {
        WCToken,
        WCTrustedToken,
      },
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  return {
    getCSRRoles,
  };
};
